module.exports = __webpack_public_path__ + "static/media/pig2019_2-sc.06e09b0a.jpg";